<template>
    <v-container fluid class="pa-5">

        <v-row justify="center" class="ma-3">
            <v-col cols="auto" class="ma-3">
                <!--<h1>{{$t('ourstory.contact')}}</h1>-->
                <v-card>
                    <v-card-title>{{$t('ourstory.contacttitle')}}</v-card-title>

                    <v-card-text>
                        <p>
                            {{$t('ourstory.address')}}
                        </p>
                        <p>
                            {{$t('ourstory.tel')}}<br>
                            {{$t('ourstory.fax')}}
                        </p>
                        <p>
                            Email: info@blitzmoda.it
                        </p>
                    </v-card-text>


                </v-card>
            </v-col>
            <v-col xl="8" lg="8" md="8" sm="12" cols="12" class="ma-3">

                <!--<h1>{{$t('ourstory.where')}}</h1>-->

                <!-- iframe generated with https://www.embedgooglemap.net/ -->
                <iframe
                        width="100%"
                        height="500"
                        id="gmap_canvas"
                        src="https://maps.google.com/maps?q=Via%20Pasitea%2038/40,%2084017%20Positano%20(SA)&t=&z=16&ie=UTF8&iwloc=&output=embed"
                        frameborder="0"
                        scrolling="no"
                        marginheight="2"
                        marginwidth="2">
                </iframe>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    export default {
        name: "Contatti"
    }
</script>

<style scoped>

</style>